import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["preserveAspectRatio", "viewBox"];
import React from 'react';

var Paper = function Paper(_ref) {
  var _ref$preserveAspectRa = _ref.preserveAspectRatio,
      preserveAspectRatio = _ref$preserveAspectRa === void 0 ? 'xMidYMid meet' : _ref$preserveAspectRa,
      _ref$viewBox = _ref.viewBox,
      viewBox = _ref$viewBox === void 0 ? '0 0 100 100' : _ref$viewBox,
      unhandledProps = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({}, unhandledProps, {
    preserveAspectRatio: preserveAspectRatio,
    viewBox: viewBox
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85.8,22.5C85.5,22.1,69.4,6.1,69.4,6.1C69.1,5.8,68.2,5,66.9,5h-37c-1.9,0-3.5,1.6-3.5,3.5v9.8h-9.8  c-1.9,0-3.5,1.6-3.5,3.5v69.8c0,1.9,1.6,3.5,3.5,3.5h53.5c1.9,0,3.5-1.6,3.5-3.5v-9.8h9.8c1.9,0,3.5-1.6,3.5-3.5c0,0,0-53.1,0-53.2  C86.9,24.4,86.5,23.2,85.8,22.5L85.8,22.5z M20.1,88V25.3h30.1v13c0,1.9,1.5,3.5,3.5,3.5h12.9V88H20.1z M73.6,74.8V38.3  c0-0.8-0.4-1.8-1-2.5L56.1,19.3c-0.4-0.5-1.3-1-2.4-1H33.4V12h30v13c0,1.9,1.6,3.5,3.5,3.5h13v46.2H73.6z"
  })));
};

Paper.displayName = 'Paper';
export default Paper;